import Tooltip from "components/atoms/Tooltip";
import { Header, Paragraph } from "components/atoms/Typography";
import { Energy, EnergyAndEquipment, Equipment, Error, NoEnergyAndEquipment } from "../DataCoverage/DataCoverageIcon";
import "./DataCoverageLine.scss";

interface DataCoverageLineProps {
    map: Map<DataCoverageEnum | "total", number>;
}

function DataCoverageLine({ map }: DataCoverageLineProps) {
    const getCount = (key: DataCoverageEnum) => map.get(key) || 0;

    const greenCount = (getCount("equipment_and_utility") + getCount("equipment_and_utility_warning")) * 2;

    const greenGreyCount =
        getCount("utility") + getCount("equipment") + getCount("utility_warning") + getCount("equipment_warning");

    const redCount = getCount("error");

    const total = map.get("total") || 1;

    const redPercent = (100 * redCount) / total;
    const greenPercent = (100 * (greenCount + greenGreyCount)) / total;
    const greenGreyPercent = (100 * greenGreyCount) / total;

    return (
        <Tooltip tooltipBody={<DataCoverageLineTooltip map={map} />}>
            <div className="data-coverage-line">
                <div className="segment green" style={{ width: `${greenPercent}%` }} />
                <div className="segment red" style={{ width: `${redPercent}%` }} />
                <div className="segment grey" style={{ width: `${greenGreyPercent}%` }} />
            </div>
        </Tooltip>
    );
}

function DataCoverageLineTooltip({ map }: DataCoverageLineProps) {
    const getCount = (key: DataCoverageEnum) => map.get(key) || 0;

    const greenCount = (getCount("equipment_and_utility") + getCount("equipment_and_utility_warning")) * 2;
    const greyCount = getCount("no_equipment_and_no_utility") + getCount("processing");
    const redCount = getCount("error");
    const utilityCount = getCount("utility") + getCount("utility_warning");
    const equipmentCount = getCount("equipment") + getCount("equipment_warning");

    return (
        <div className="data-coverage-line-tooltip">
            <Header size="x-small" style={{ color: "var(--audette-gray-500)" }}>
                Data coverage
            </Header>

            <div className="tooltipContainer">
                <EnergyAndEquipment />
                <Header size="x-small">Energy & equipment added</Header>
                <Paragraph>{greenCount}</Paragraph>
            </div>
            <div className="tooltipContainer">
                <Energy />
                <Header size="x-small">Energy added</Header>
                <Paragraph>{utilityCount}</Paragraph>
            </div>
            <div className="tooltipContainer">
                <Equipment />
                <Header size="x-small">Equipment added</Header>
                <Paragraph>{equipmentCount}</Paragraph>
            </div>
            <div className="tooltipContainer">
                <Error />
                <Header size="x-small">Failed modelling</Header>
                <Paragraph>{redCount}</Paragraph>
            </div>
            <div className="tooltipContainer">
                <NoEnergyAndEquipment />
                <Header size="x-small">No data</Header>
                <Paragraph>{greyCount}</Paragraph>
            </div>
        </div>
    );
}

export default DataCoverageLine;
